import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ShopPage } from "../components/shop/shop-page.tsx";

interface Search {
  readonly kategori?: string;
  readonly q?: string;
}

export const Route = createFileRoute("/butik/")({
  component: Screen,
  validateSearch: (search: Record<string, unknown>): Search => ({
    ...(typeof search.kategori === "string" ? { kategori: search.kategori } : {}),
    ...(typeof search.q === "string" && search.q !== "" ? { q: search.q } : {}),
  }),
});

function Screen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <ShopPage
      filter={{ category: search.kategori ?? null, query: search.q ?? "" }}
      onFilterChange={(next) =>
        void navigate({
          search: {
            ...(next.category === null ? {} : { kategori: next.category }),
            ...(next.query === "" ? {} : { q: next.query }),
          },
          replace: true,
        })
      }
    />
  );
}
